<template>
  <div class="selectArea">
    <div class="titleInfo">
        <div class="left"><i class="iconfont icon-wxbdingwei" style="margin-right:5px;"></i>行政区划定位</div>
        <div class="right">
            <i class="iconfont icon-guanbi" @click="handleCancel"></i>
        </div>
    </div>
    <div class="contentCal">
        <!-- 省 -->
        <ul class="ulsP">
            <div class="leftTitle">省：</div>
            <li class="lisP" @click="selectAreaProvice(indexP)" v-for="(nav,indexP) in areaList" :key="indexP">
                <div :class="activeIndex === indexP?'rightTitle activeRightTitle':'rightTitle'">{{nav.label}}</div>
            </li>
        </ul>
        <!-- 市 -->
        <ul class="uls">
            <div class="leftTitle">市：</div>
            <div class="rightBox">
                <ul :class="cityFlag ? 'Cityuls' : 'Cityuls notMore'">
                    <li v-for="(nav,indexC) in areaListCity" :key="indexC" class="lis" @click="selectCity(indexC)">
                        <div :class="activeIndexC === indexC?'rightTitle activeRightTitle':'rightTitle'" v-if="cityFlag?1000000:indexC<7">{{nav.label}}</div>
                    </li>
                    <p class="more" :class="cityFlag ? 'active' : ''"  @click="ckdMore" v-if="areaListCity.length > 7">
                        {{cityFlag?'收起':'更多'}}<Icon :type="cityFlag ? 'ios-arrow-up' : 'ios-arrow-down'" />
                    </p>
                </ul>
            </div>
        </ul>
        <!-- 县 -->
        <ul class="uls">
            <div class="leftTitle">区县：</div>
            <div class="rightBox">
                <ul :class="countyFlag ? 'Cityuls' : 'Cityuls notMore'">
                    <li v-for="(nav,indexQ) in areaCountyList" :key="indexQ" class="lis" @click="selectCounty(indexQ)">
                        <div :class="activeIndexQ === indexQ?'rightTitle activeRightTitle':'rightTitle'" v-if="countyFlag?1000000:indexQ<7">{{nav.label}}</div>
                    </li>
                    <p class="more" :class="countyFlag ? 'active' : ''"  @click="qxMore" v-if="areaCountyList.length > 7">
                        {{countyFlag?'收起':'更多'}}<Icon :type="countyFlag ? 'ios-arrow-up' : 'ios-arrow-down'" />
                    </p>
                </ul>
            </div>
        </ul>
    </div>
    <div class="footerCal">
        <div class="oncheck">
            <Button class="infoclose" @click.stop="handleCancel">关闭</Button>
        </div>
    </div>
  </div>
</template>

<script>
import { getAreaList , getJSONByCode } from '@/api/index.js'
export default {
    name:"selectArea",
    data(){
        return{
            areaList:[],
            copyList:[],
            areaListCity:[],
            areaCountyList:[],
            CityfeatureArr:[],
            proviceFeatureArr:[],
            countyFeatureArr:[],
            activeIndex:0,
            activeIndexC:-1,
            activeIndexQ:-1,
            cityFlag:false,
            countyFlag:false,
            selectIndexObj:{
                activeIndex:0,
                activeIndexC:-1,
                activeIndexQ:-1,
            }
        }
    },
    computed:{
        setAreaCode(){
            return this.$store.state.app.setAreaCode
        }
    },
    created(){
        this.activeIndex = this.setAreaCode.activeIndex
        this.activeIndexC = this.setAreaCode.activeIndexC
        this.activeIndexQ = this.setAreaCode.activeIndexQ
        this.selectAreaList();
    },
    mounted(){

    },
    methods:{
        // 选择行政区划列表
        selectAreaList(){
            getAreaList().then(res =>{
                if(res.code == 200 && res.success) {
                    this.areaList = res.result
                    this.copyList = JSON.parse(JSON.stringify(res.result))
                    this.areaListCity = res.result[0].children
                    if(this.activeIndex === 0 && this.activeIndexC == -1 && this.activeIndexQ == -1) {
                        this.getJSONArea(this.copyList[this.activeIndex] , 'provice');//初始叠加省的数据
                    }
                    if(this.activeIndexC !=-1 && this.activeIndex !=-1 ){
                        this.areaCountyList = this.copyList[this.activeIndex].children[this.activeIndexC].children ; //获取区县的数据
                    }
                }
            })
        },
        // 选择行政区划的事件
        selectAreaProvice(code){
            this.activeIndex = code;
            this.activeIndexC = -1;
            this.selectIndexObj.activeIndexC = -1;
            // 移除省边界
            if(this.proviceFeatureArr.length>0) {
                this.proviceFeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.proviceFeatureArr = []
            }
            // 移除市边界
            if(this.CityfeatureArr.length>0) {
                this.CityfeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.CityfeatureArr = []
            }
            // 移除县边界
            if(this.countyFeatureArr.length>0) {
                this.countyFeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.countyFeatureArr = []
            }
            this.selectIndexObj.activeIndex = code
            this.$store.commit("setAreaCode" ,this.selectIndexObj)
            var objData = this.areaList[code]
            this.getJSONArea(this.copyList[this.activeIndex] , 'provice')
        },
        getJSONArea(code ,type){
            var param = {
                areaCode:code.value
            }
            getJSONByCode(param).then(res =>{
                if(res.code == 200 && res.success) {
                    var centerArr = res.result.center.indexOf(',')!=-1?res.result.center.split(","):[]
                    // 对中心点进行偏移操作在屏幕中间
                    var location = [parseFloat(centerArr[0]) , parseFloat(centerArr[1]) + 0.2]
                    this.olmap.getView().animate({
                        center: location,
                        duration: 2000,
                        zoom:  type == 'provice'?6.5:9,
                        easing: this.$olmap.easing.Linear,
                    });
                    // 获取单独一个市的边界线
                    var dataCity = res.result.cityMap.features;
                    dataCity.forEach((item) => {
                        var polygonProvice = this.publicMethod.createLayerLine(this.$olmap , item, '#ff0000', code.value)
                        if(type == 'provice') {
                            this.proviceFeatureArr.push(polygonProvice)
                            this.$emit("selectAreaData" , this.proviceFeatureArr)
                        } else if(type == 'city') {
                            this.CityfeatureArr.push(polygonProvice);
                            this.$emit("selectAreaData" , this.CityfeatureArr)
                        } else if(type == 'county'){
                            this.countyFeatureArr.push(polygonProvice)
                            this.$emit("selectAreaData" , this.countyFeatureArr)
                        }
                        this.olmap.addLayer(polygonProvice);
                        polygonProvice.setZIndex(996);
                    });
                }
            })
        },
        // 选择市的事件
        selectCity(record) {
            // 移除省边界
            if(this.proviceFeatureArr.length>0) {
                this.proviceFeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.proviceFeatureArr = []
            }
            // 移除市边界
            if(this.CityfeatureArr.length>0) {
                this.CityfeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.CityfeatureArr = []
            }
            // 移除县边界
            if(this.countyFeatureArr.length>0) {
                this.countyFeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.countyFeatureArr = []
            }
            // 移除县级叠加行政区划的数据
            this.activeIndexC = record;
            this.selectIndexObj.activeIndexC = record
            this.activeIndexQ = -1
            this.selectIndexObj.activeIndexQ = -1
            this.$store.commit("setAreaCode" ,this.selectIndexObj)
            this.areaCountyList = this.copyList[this.activeIndex].children[this.activeIndexC].children ; //获取区县的数据
            // 叠加市级的行政区划数据
            this.getJSONArea(this.copyList[this.activeIndex].children[this.activeIndexC] ,'city')
        },
        // 选择区县的事件
        selectCounty(record){
            // 移除省边界
            if(this.proviceFeatureArr.length>0) {
                this.proviceFeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.proviceFeatureArr = []
            }
            // 移除市边界
            if(this.CityfeatureArr.length>0) {
                this.CityfeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.CityfeatureArr = []
            }
            // 移除县边界
            if(this.countyFeatureArr.length>0) {
                this.countyFeatureArr.forEach((item,index) =>{
                    this.olmap.removeLayer(item)
                })
                this.countyFeatureArr = []
            }
            this.activeIndexQ = record;
            this.selectIndexObj.activeIndexQ = record
            this.selectIndexObj.activeIndexC = this.activeIndexC
            this.$store.commit("setAreaCode" ,this.selectIndexObj)
            this.getJSONArea(this.copyList[this.activeIndex].children[this.activeIndexC].children[this.activeIndexQ] , 'county')
        },
        // 点击市级查看更多
        ckdMore(){
            this.cityFlag = !this.cityFlag
        },
        // 点击区县查看更多
        qxMore(){
            this.countyFlag = !this.countyFlag
        },
        // 点击关闭弹框的按钮
        closeLayer(){
            this.clearDraw();
            this.$emit("closeLayerArea")
        },
        // 点击关闭的按钮
        handleCancel(){
            this.$emit("closeLayerArea")
        },
    }
}
</script>

<style lang="less" scoped>
.selectArea{
    position: absolute;
    top:50px;
    right: 18px;
    z-index: 900;
    width: 340px;
    height: 340px;
    border-radius: 5px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    .titleInfo{
        width:100%;
        height: 40px;
        border-bottom: 1px solid #f2f2f2;
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        .icon-wxbdingwei{
            color: #0099fa;
        }
        .left{
            height: 40px;
            line-height: 40px;
            font-size: 16px;
        }
        .right{
            line-height: 40px;
            cursor: pointer;
            .icon-guanbi{
                font-size: 30px;
            }
        }
    }
    .contentCal{
        width: 100%;
        flex: 1;
        overflow-y: auto;
        .ulsP{
            display: flex;
            border-bottom: 2px solid #f5f5f5;
            .leftTitle{
                width: 65px;
                line-height: 50px;
                padding-left:10px;
            }
            .lisP{
                width: 100%;
                display: flex;
                padding: 0 10px 0 0;
                .rightTitle{
                    cursor: pointer;
                    padding: 5px 7px;
                    height: 30px;
                    border-radius: 8px;
                    margin-top: 10px;
                    border: 1px solid #ccc;
                }
                .activeRightTitle{
                    background: #0099fa;
                    color: #ffffff;
                }
            }
        }
        .uls{
            display: flex;
            .leftTitle{
                width: 65px;
                min-height: 50px;
                line-height: 50px;
                padding-left:10px;
            }
            .rightBox{
                width: 100%;
                .Cityuls{
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                    .lis{
                        cursor: pointer;
                        .rightTitle{
                            padding: 5px 7px;
                            height: 30px;
                            border-radius: 8px;
                            margin-top: 10px;
                            border: 1px solid #ccc;
                            margin-right: 6px;
                        }
                        .activeRightTitle{
                            background: #0099fa;
                            color: #ffffff;
                        }
                    }
                    .more{
                        cursor: pointer;
                        padding: 5px 8px;
                        height: 30px;
                        border-radius: 8px;
                        margin-top: 10px;
                        border: 1px solid #0099fa;
                        color: #0099fa;
                    }
                }
                .notMore{
                    height: 80px;
                    overflow: hidden;
                }
            }
        }
    }
    .footerCal{
        width: 100%;
        height: 55px;
        border-top: 1px solid #e8e8e8;
        text-align: right;
        padding-top: 10px;
        .oncheck {
            .infoclose {
                margin-left: 10px;
                margin-right: 15px;
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/maptools/selectArea.vue